var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 49,
    height: 49,
    fill: "#FF5D5E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 51,
    height: 51,
    stroke: "black",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8654 7H10.1346C8.404 7 7 8.404 7 10.1346V42.8654C7 44.596 8.404 46 10.1346 46H42.8654C44.596 46 46 44.596 46 42.8654V10.1346C46 8.404 44.596 7 42.8654 7ZM42.8654 42.88C21.0351 42.8751 10.12 42.8703 10.12 42.8654C10.1249 21.0351 10.1298 10.12 10.1346 10.12C31.9649 10.1249 42.88 10.1298 42.88 10.1346C42.8751 31.9649 42.8703 42.88 42.8654 42.88ZM12.7818 21.6201H18.5684V40.2329H12.7818V21.6201ZM15.6775 19.0754C17.5251 19.0754 19.0315 17.5739 19.0315 15.7214C19.0315 15.2809 18.9447 14.8448 18.7762 14.4379C18.6076 14.0309 18.3606 13.6612 18.0491 13.3497C17.7377 13.0383 17.3679 12.7912 16.961 12.6227C16.5541 12.4541 16.118 12.3674 15.6775 12.3674C15.237 12.3674 14.8009 12.4541 14.394 12.6227C13.9871 12.7912 13.6173 13.0383 13.3059 13.3497C12.9944 13.6612 12.7474 14.0309 12.5788 14.4379C12.4103 14.8448 12.3235 15.2809 12.3235 15.7214C12.3186 17.5739 13.8201 19.0754 15.6775 19.0754ZM27.9771 31.024C27.9771 28.5962 28.4402 26.2465 31.4481 26.2465C34.4121 26.2465 34.456 29.0204 34.456 31.18V40.2329H40.2377V30.0246C40.2377 25.0131 39.1555 21.157 33.3006 21.157C30.4877 21.157 28.6011 22.7024 27.826 24.1649H27.748V21.6201H22.1954V40.2329H27.9771V31.024Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_229",
    x: 0,
    y: 0,
    width: 57,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_229"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_229",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c89c689db6d92b4e2f9e8220d1e193db.svg";
export { ForwardRef as ReactComponent };